<template>
  <Modal
    :id="id"
    :modalTitle="modalTitle"
    :class="classes"
    hide-footer
    :onClose="onClose"
    :updateFunction="tabselected === 'content1' && !isBusinessContract ? rechargeOnDemand : undefined"
    :updateStatus="loadingContractData"
    :updateTitle="'Actualizar Planes de Pago'"
  >
    <template v-if="tabselected === 'content1'">
      <!-- Vista para contratos de empresas -->
      <template v-if="isBusinessContract">
        <div
          class="d-flex align-items-start justify-content-between flex-wrap mb-3"
        >
          <div class="pr-3 mb-1">
            <div class="generalTitleItemModal">Id contrato</div>
            <div>{{ cuotes.contractId }}</div>
          </div>
          <div class="pr-3 mb-1">
            <div class="generalTitleItemModal">Número de cuotas</div>
            <div>{{ cuotes.numFees }}</div>
          </div>
          <div class="pr-3 mb-1">
            <div class="generalTitleItemModal">Estado del plan</div>
            <div
              v-bind:class="{
                'border-success text-success': cuotes.status == 'STARTED' || cuotes.status == 'PAID',
                'border-danger text-danger': cuotes.status == 'CANCELED',
                'border-info text-info': cuotes.status == 'CREATED' || cuotes.status == 'PENDING',
                'border-light text-light bg-danger': cuotes.status == 'UNPAID',
                'border-dark text-muted': cuotes.status == 'FINISHED',
              }"
              class="badge border text-uppercase"
            >
              {{ cuotes.statusMessage || cuotes.status || "-" }}
            </div>
          </div>
        </div>
      </template>

      <!-- Vista para contratos normales -->
      <template v-else>
        <div
          class="d-flex align-items-start justify-content-between flex-wrap mb-3"
        >
          <div class="pr-3 mb-1">
            <div class="generalTitleItemModal">Id contrato</div>
            <div>{{ cuotes.contractId }}</div>
          </div>
          <div class="pr-3 mb-1">
            <div class="generalTitleItemModal">Cantidad por cuota</div>
            <div>{{ cuotes.amount }}€</div>
          </div>
          <div class="pr-3 mb-1">
            <div class="generalTitleItemModal">Número de cuotas</div>
            <div>{{ cuotes.numFees }}</div>
          </div>
          <div class="pr-3 mb-1">
            <div class="generalTitleItemModal">Estado del plan</div>
            <div
              v-bind:class="{
                'border-success text-success': cuotes.status == 'STARTED',
                'border-danger text-danger': cuotes.status == 'CANCELED',
                'border-info text-info': cuotes.status == 'CREATED',
                'border-light text-light bg-danger': cuotes.status == 'UNPAID',
                'border-dark text-muted': cuotes.status == 'FINISHED',
              }"
              class="badge border text-uppercase"
            >
              {{ cuotes.status || "-" }}
            </div>
          </div>
          <div class="pr-3 mb-1">
            <div class="generalTitleItemModal">Tarjeta de pago</div>
            <a
              href="#"
              class="mr-4 pb-2 d-flex btn btn-outline-primary text-nowrap"
              @click="
                changePayMethod();
                onClose();
              "
            >
              Cambiar tarjeta
            </a>
          </div>
        </div>
      </template>
      <div v-if="loadingContractData" class="row mt-3">
        <div class="col-12 text-center">
          <img src="@/assets/loaderPrimary.svg" height="150" alt="" />
        </div>
      </div>
      <div v-if="errorContractData != '' && !loadingContractData" class="row mt-3">
        <div class="col-12">
          <div class="generalTitleItemModal text-danger">{{ errorContractData }}</div>
        </div>
      </div>
      <template v-if="errorContractData == '' && !loadingContractData">
        <div class="overflow-auto customTable">
          <!-- Tabla para contratos de empresas -->
          <table v-if="isBusinessContract" class="table">
            <thead>
              <tr>
                <th class="align-middle">Nº Cuota</th>
                <th class="align-middle">Fecha prevista</th>
                <th class="align-middle">Fecha pago</th>
                <th class="align-middle text-center">Importe</th>
                <th class="align-middle text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cuote, index) in fees" :key="index">
                <td class="align-middle">{{ cuote.num }}</td>
                <td class="align-middle">
                  {{ $dateBackToFront(cuote.expectedDate) }}
                </td>
                <td class="align-middle">
                  {{ cuote.paymentDate ? $dateBackToFront(cuote.paymentDate) : '-' }}
                </td>
                <td class="align-middle text-center">
                  {{ cuote.amount ? cuote.amount + '€' : '-' }}
                </td>
                <td id="estados" class="align-middle">
                  <div
                    v-bind:class="{
                      'border-success text-success': cuote.status == 'PAID',
                      'border-danger text-danger': cuote.status == 'CANCELED',
                      'border-info text-info': cuote.status == 'PENDING',
                      'border-light text-light bg-danger': cuote.status == 'UNPAID',
                      'border-warning text-warning': cuote.status == 'PROCESSING',
                    }"
                    class="badge border text-uppercase"
                  >
                    {{ cuote.statusMessage || cuote.status || "-" }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Tabla para contratos normales -->
          <table v-else class="table">
            <thead>
              <tr>
                <th class="align-middle">Nº Cuota</th>
                <th class="align-middle">Fecha cobro</th>
                <th class="align-middle">Fecha pago</th>
                <th class="align-middle text-center">Cuota</th>
                <th class="align-middle text-center">Penalización</th>
                <th class="align-middle text-center">Fecha P.</th>
                <th class="thOperaciones"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cuote, index) in fees" :key="index">
                <td class="align-middle">{{ cuote.num }}</td>
                <td class="align-middle">
                  {{ $dateBackToFront(cuote.expectedDate) }}
                </td>
                <td class="align-middle">
                  {{ $dateBackToFront(cuote.paymentDate) }}
                </td>
                <td id="estados" class="align-middle">
                  <div
                    v-bind:class="{
                      'border-success text-success': cuote.status == 'PAID',
                      'border-danger text-danger': cuote.status == 'CANCELED',
                      'border-info text-info': cuote.status == 'PENDING',
                      'border-light text-light bg-danger':
                        cuote.status == 'UNPAID',
                      'border-warning text-warning': cuote.status == 'PROCESSING',
                    }"
                    class="badge border text-uppercase"
                  >
                    {{ cuote.status || "-" }}
                  </div>
                </td>
                <td class="align-middle">
                  <div class="text-center">
                    {{
                      cuote.totalCommission ? cuote.totalCommission + "€" : "-"
                    }}
                  </div>
                </td>
                <td class="align-middle">
                  <div class="text-center">
                    {{ $dateBackToFront(cuote.paymentDateCommission) }}
                  </div>
                </td>
                <td id="operaciones" class="align-middle tdOperaciones">
                  <div
                    class="dropdown dropdown-inherit"
                    v-if="
                      cuote.status == 'UNPAID' &&
                      (cuote.showPenalty || cuote.showCuota)
                    "
                  >
                    <span
                      id="dropdownOperations"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <v-icon name="fa-ellipsis-v" />
                    </span>
                    <div
                      class="dropdown-menu p-0 dropdown-menu-right"
                      aria-labelledby="dropdownOperations"
                    >
                      <a
                        v-if="cuote.showPenalty"
                        href="#"
                        class="dropdown-item py-3 px-4"
                        @click="
                          selectTab('content2');
                          cuoteNum = cuote.num;
                        "
                      >
                        Penalización
                      </a>
                      <a
                        v-if="cuote.showCuota"
                        href="#"
                        class="dropdown-item py-3 px-4"
                        @click="
                          selectTab('content4');
                          cuoteNum = cuote.num;
                        "
                      >
                        Cuota
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          :currentPage="currentPage"
          :numberPages="numberPages"
          @selectPage="selectPage($event)"
        />
      </template>
    </template>
    <template v-if="tabselected === 'content2'">
      <div class="row mt-3">
        <div class="col-12">
          <p>Se va a realizar una petición de penalización</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h-100 d-flex justify-content-between">
            <div>
              <button
                class="btn generalSecondaryButton"
                @click="selectTab('content1')"
                :disabled="loading"
              >
                Atrás
              </button>
            </div>
            <div>
              <img
                v-if="loading"
                src="../../../../../assets/loaderPrimary.svg"
                height="40"
                alt=""
              />
              <button
                class="btn btn-primary generalPrimaryButton"
                v-if="!loading"
                @click="penalizacion()"
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabselected === 'content3'">
      <div class="row mt-3">
        <div class="col-12">
          <p>Penalización realizado correctamente</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h-100 d-flex justify-content-end">
            <div>
              <button
                class="btn btn-primary generalPrimaryButton"
                @click="
                  loadContractData();
                  selectTab('content1');
                "
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabselected === 'content4'">
      <div class="row mt-3">
        <div class="col-12">
          <p>Se va a realizar el cobro de la cuota</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h-100 d-flex justify-content-between">
            <div>
              <button
                class="btn generalSecondaryButton"
                @click="selectTab('content1')"
                :disabled="loading"
              >
                Atrás
              </button>
            </div>
            <div>
              <img
                v-if="loading"
                src="../../../../../assets/loaderPrimary.svg"
                height="40"
                alt=""
              />
              <button
                class="btn btn-primary generalPrimaryButton"
                v-if="!loading"
                @click="cobrarCuota()"
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabselected === 'content5'">
      <div class="row mt-3">
        <div class="col-12">
          <p>Cuota cobrada correctamente</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h-100 d-flex justify-content-end">
            <div>
              <button
                class="btn btn-primary generalPrimaryButton"
                @click="
                  loadContractData();
                  selectTab('content1');
                "
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabselected === 'content6'">
      <div class="row mt-3">
        <div class="col-12">
          <p>{{ messageError }}</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h-100 d-flex justify-content-end">
            <div>
              <button
                class="btn btn-primary generalPrimaryButton"
                @click="
                  loadContractData();
                  selectTab('content1');
                  messageError = '';
                "
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <button
      :id="id + 'CierreModal'"
      style="display: none"
      data-dismiss="modal"
    />
  </Modal>
  <ConfirmChangePayMethod
    :contractId="contractId"
    :id="'changePayMethod'"
    :modalTitle="'Solicitar cambio de tarjeta de pago'"
    :showFooter="false"
  >
  </ConfirmChangePayMethod>
</template>

<script>
import axios from "axios";
import Modal from "../../../Shared/Modal.vue";
import { Modal as ModalBootstrap } from "bootstrap";
import Pagination from "@/components/Widgets/Shared/Pagination.vue";
import ConfirmChangePayMethod from "./ConfirmChangePayMethod.vue";
import moment from "moment";

export default {
  name: "ContractDetail",
  props: ["id", "modalTitle", "class", "contractId"],
  data() {
    return {
      classes: this.class,
      cuotes: "",
      fees: "",
      currentPage: 0,
      numberPages: 0,
      tabselected: "content1",
      cuoteNum: 0,
      loading: false,
      messageError: "",
      errorContractData: "",
      loadingContractData: false,
    };
  },
  computed: {
    isBusinessContract() {
      return this.$store.state.roles.Backoffice_member_empresas;
    }
  },
  mounted() {
    this.loadContractData();
  },
  components: {
    Modal,
    Pagination,
    ConfirmChangePayMethod,
  },
  methods: {
    loadContractData() {
      this.loadingContractData = true;
      this.errorContractData = "";

      // Endpoint diferente según el tipo de contrato
      const endpoint = this.isBusinessContract
        ? `/contract/business/payment-plan/${this.contractId}`
        : `/contract/${this.contractId}/payment-plan`;

      axios
        .get(endpoint)
        .then((response) => {
          // Solo procesar lógica de penalización/cobro para contratos normales
          if (!this.isBusinessContract && ["STARTED", "CREATED", "UNPAID"].includes(response.data.status)) {
            let index = null;
            let fechaAux = null;
            let indexAux = -1;
            const nowDate = moment();
            for (const cuota of response.data.fees) {
              indexAux = indexAux + 1;
              if (
                cuota.status === "UNPAID" &&
                (index === null || cuota.expectedDate < fechaAux)
              ) {
                index = indexAux;
                fechaAux = cuota.expectedDate;
              }
              if (cuota.status === "UNPAID" && !cuota.totalCommission) {
                const expectedDate = moment(cuota.expectedDate).add(5, "days");
                if (nowDate >= expectedDate) {
                  cuota.showPenalty = true;
                }
              }
            }
            if (index !== null) {
              response.data.fees[index].showCuota = true;
            }
          }
          this.cuotes = response.data;
          this.paginacion(response.data.fees || []);
          this.numberPages = Math.ceil((response.data.fees || []).length / 25);
          this.loadingContractData = false;
        })
        .catch(() => {
          this.loadingContractData = false;
          this.errorContractData = "Ha ocurrido un error, inténtelo de nuevo. Si el problema persiste contacte con el administrador del sistema.";
        });
    },
    paginacion(value) {
      let start = this.currentPage * 25;
      console.log("start : " + start);
      this.fees = value.slice(start, start + 25);
      console.log(this.fees);
    },
    selectTab(id) {
      this.tabselected = id;
    },
    penalizacion() {
      this.loading = true;
      this.messageError = "";
      const bodyToSend = {
        numReceipt: this.cuoteNum,
      };
      axios
        .post(
          `/payment/${this.contractId}/payment-plan/fees/commission`,
          bodyToSend
        )
        .then((response) => {
          console.log(response);
          this.loading = false;
          this.tabselected = "content3";
        })
        .catch((error) => {
          this.loading = false;
          this.tabselected = "content6";
          this.messageError = error.response.data.message;
        });
    },
    cobrarCuota() {
      this.loading = true;
      this.messageError = "";
      const bodyToSend = {
        numReceipt: this.cuoteNum,
        takeQuota: true,
      };
      axios
        .post(
          `/payment/${this.contractId}/payment-plan/fees/commission`,
          bodyToSend
        )
        .then((response) => {
          console.log(response);
          this.loading = false;
          this.tabselected = "content5";
        })
        .catch((error) => {
          this.loading = false;
          this.tabselected = "content6";
          this.messageError = error.response.data.message;
        });
    },

    selectPage(value) {
      this.currentPage = value;
      this.loadContractData();
    },
    changePayMethod() {
      console.log("Call modal");
      var myModal = new ModalBootstrap(
        document.getElementById("changePayMethod")
      );
      myModal.show();
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", "");
    },
    rechargeOnDemand(){
      this.loadingContractData = true;
      this.errorContractData = "";
      axios.put(`/payment/${this.contractId}/payment-plan/refresh`)
        .then(() => {
          this.loadContractData();
        })
        .catch(() => {
          this.loadingContractData = false;
          this.errorContractData = "Ha ocurrido un error, inténtelo de nuevo. Si el problema persiste contacte con el administrador del sistema.";
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#estados {
  text-align: center;
}
.customTable {
  .table th,
  .table td {
    padding: 0.35rem !important;
  }
}
</style>
